export default __webpack_public_path__ + "slices/main/assets/public/media/camper-underlines/underline.08e40e989ee1ceccc7be36ad679d878b.svg";